import { EMeasureReferenceType } from "../enum/measure-reference-type"

export class MeasureReference {

    Name: string
    ChipName: string
    Code: string
    Color: string
    TextColor: string
    Designation: string
    LabObjectiveIndoor: string
    LabObjectiveOutdoor: string
    SamplingDurationIndoor: string
    SamplingDurationOutdoor: string
    SamplingConditionUsedRoom: string
    SamplingConditionEmptyRoom: string
    Type: EMeasureReferenceType;
    IsActive: boolean;

    static mapFromJSON(json) {
        const i = new MeasureReference();

        i.Name = json['name'];
        i.ChipName = json['chipName'];
        i.Code = json['code'];
        i.TextColor = json['textColor'];
        i.Designation = json['designation'];
        i.LabObjectiveIndoor = json['labObjectiveIndoor'];
        i.LabObjectiveOutdoor = json['labObjectiveOutdoor'];
        i.SamplingDurationIndoor = json['samplingDurationIndoor'];
        i.SamplingDurationOutdoor = json['samplingDurationOutdoor'];
        i.SamplingConditionUsedRoom = json['samplingConditionUsedRoom'];
        i.SamplingConditionEmptyRoom = json['samplingConditionEmptyRoom'];
        i.Type = json['type'];
        i.IsActive = json['isActive'];

        return i;
    }
}